var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Flex } from "./..";
import { ToggleIndicator } from './ToggleIndicator';
export var LabelWithToggle = function (_a) {
    var _b = _a.label, label = _b === void 0 ? '' : _b, _c = _a.isOutlineToggle, isOutlineToggle = _c === void 0 ? false : _c, _d = _a.isOpen, isOpen = _d === void 0 ? false : _d, _e = _a.isFullscreen, isFullscreen = _e === void 0 ? false : _e;
    return (React.createElement(Flex, { as: "span", lss: __assign({ alignItems: 'center' }, (isFullscreen && { width: '100%' })) },
        React.createElement(Flex, { lss: { marginRight: isFullscreen ? 'auto' : 'none' } }, label),
        React.createElement(Flex, { as: "span", lss: { ml: 'sm' } },
            React.createElement(ToggleIndicator, { isOpen: isOpen, isOutline: isOutlineToggle }))));
};
//# sourceMappingURL=LabelWithToggle.js.map